export function DiagramScrollLock() {
    $('html').addClass('scroll-locked');
};

export function DiagramScrollUnlock() {
    $('html').removeClass('scroll-locked');
};